export default __webpack_public_path__ + "static/media/acc-square.b25371cf.svg";